import '../applied_filter_view.js.coffee';# Added by Script 
Monitoring.Views.SocialContents ||= {}
Monitoring.Views.SocialContents.Filters ||= {}

class Monitoring.Views.SocialContents.Filters.AppliedTypeView extends Monitoring.Views.SocialContents.Filters.AppliedFilterView
  name: 'type'
  alias: 'Source'
  humanize: true

  removeFilter: (value) ->
    @searchQuery.removeType(value)

  clear: =>
    @searchQuery.resetField('is_reply_list')
    super